<template>
  <div class="live-detail">
    <span v-show="!isFullScreen" class="icon" @click.prevent="back">
      <img alt src="@/assets/return.png" />
    </span>
    <div class="player" :style="{ width: `${width}px`, height: `${height}px` }">
      <!-- <m-player
        ref="player"
        v-if="(detail.liveStatus === 0 || haveVideo === true) && !isShowLogin && isStart"
        :src="detail.livePlayHlsUrl"
        :live="detail.liveStatus === 0"
        :liveStatus="detail.liveStatus"
        :flag="flag"
      /> -->
      <node-player
        v-if="(detail.liveStatus === 0 || haveVideo === true) && !isShowLogin && isStart"
        ref="player"
        :src="detail.livePlayHlsUrl"
        :live="true"
        :end="liveEnd"
        @onFullScreen="handleFullScreen"
        @onError="urlError"
      />
      <div v-else class="course-tip">
        {{ tips }}
      </div>
    </div>
    <comments
      v-if="!isFullScreen"
      ref="comments"
      :live="detail"
      @changeTip="tipChangeHandle"
      @playVideo="handleVideoChange"
    />
    <div v-if="!isFullScreen" class="float-operation">
      <m-suspend-button :top="400" text="" @onSuspendBtnClick="share">
        <img v-if="detail.liveStatus !== 2" alt src="@/assets/living-share.png" slot="icon" />
      </m-suspend-button>
      <m-suspend-button :top="460" :text="praiseCount.toString()" @onSuspendBtnClick="praise">
        <img v-if="detail.liveStatus == 2" src="@/assets/living-like-none.png" slot="icon" />
        <img v-else src="@/assets/living-like.png" slot="icon" />
      </m-suspend-button>
    </div>
    <share-login
      :isShowLogin="isShowLogin"
      @changeShowLogin="changeShowLogin"
      ref="popup"
      @hide="resetPlay"
    />

    <img
      v-if="!isFullScreen"
      class="watermark"
      src="@/assets/watermark/watermark.png"
      slot="icon"
      :style="{
        position: 'absolute',
        left: '0px',
        bottom: '160px',
        transform: 'rotate(-45deg)',
        width: `${watermarkWidth}px`,
        opacity: 0.3
      }"
    />
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import MPlayer from '@/components/MPlayer/IndexCode.vue';
import NodePlayer from '@/components/MPlayer/nodePlayer.vue';
import liveApi from '@/api/live';
import playerMixin from '@/mixins/player';
import liveMixin from '@/mixins/liveCode';
import MSuspendButton from '@/components/MSuspendButton/IndexCode.vue';
import Comments from './commentsCode';
import ShareLogin from '@/pages/ShareLogin/index.vue';

export default {
  name: 'live-detail-code',
  components: {
    MPlayer,
    NodePlayer,
    Comments,
    ShareLogin,
    MSuspendButton
  },
  data() {
    return {
      mobile: '',
      // detail: {},
      haveVideo: false,
      videoPlaying: false,
      isStart: false,
      liveEnd: false,
      // tips: '老师正在准备课程，请耐心等待',
      detail: {
        id: '',
        liveId: '',
        title: '',
        userName: '',
        livePath: '',
        liveStatus: '',
        isLiveServer: '',
        viewCounts: '',
        startTime: '',
        livePassword: ''
      },
      schoolName: '',
      streamStatus: false,
      praiseCount: 0,
      isPraise: false,
      isShowLogin: false,
      flag: true,
      liveInfoInterval: null,
      watermarkWidth: 0,
      isFullScreen: false
    };
  },
  mixins: [playerMixin, liveMixin],
  computed: {
    tips() {
      let tip2048 = '';
      if (this.detail.liveStatus === 1) {
        tip2048 = '老师还未进入课堂，请耐心等待';
      } else if (this.detail.liveStatus === 2) {
        tip2048 = '当前直播已结束';
      }
      return tip2048;
    },
    ...mapGetters(['userInfo', 'visitorInfo'])
  },
  mounted() {
    this.watermarkWidth = document.body.clientWidth;
    this.mobile = this.$route.params.mobile;
    this.getLiveDetail();
    this.liveInfoInterval = setInterval(() => {
      this.getInfo();
    }, 1000 * 30);
  },
  watch: {
    'detail.liveId'() {
      this.getTotalPraise();
    },
    'detail.liveStatus'() {
      this.isStart = this.detail.liveStatus === 0;
    }
  },
  destroyed() {
    clearInterval(this.liveInfoInterval);
  },
  methods: {
    tipChangeHandle(type) {
      const that = this;
      if (!type) {
        // 因为流延迟问题，直播结束后延迟30秒结束
        that.liveEnd = true;
        setTimeout(() => {
          that.isStart = type;
          that.tips = '当前直播已结束';
        }, 30 * 1000);
      } else {
        this.isStart = type;
      }
    },
    getTotalPraise() {
      let params = {
        id: this.detail.liveId,
        type: 1
      };
      liveApi.fetchLivePraiseCount(params).then(res => {
        if (res.code === 0) {
          this.praiseCount = res.result;
        }
      });
    },
    praise() {
      if (this.detail.liveStatus === 2) {
        this.$createToast({
          txt: '当前直播已结束',
          type: 'warn'
        }).show();
        return;
      }
      let visitorInfo = JSON.parse(global.localStorage.getItem('visitorInfo'));
      let userInfo = JSON.parse(global.localStorage.getItem('userInfo'));
      let mobile = '';
      if (userInfo) {
        mobile = userInfo.mobile;
      }
      if (this.isVisitor) {
        if (!visitorInfo && !userInfo) {
          // 分享页，未登录
          const shareLive = this.$refs.popup;
          shareLive && shareLive.show(true);
          return;
        } else {
          mobile = visitorInfo.mobile;
        }
      }

      let params = {
        id: this.detail.liveId,
        mobile: mobile,
        schoolName: this.detail.schoolName,
        type: 1
      };
      liveApi.addPraise(params).then(res => {
        if (res.result === true) {
          this.$createToast({
            txt: '点赞成功',
            type: 'success'
          }).show();
          // 获取点赞总数
          this.getTotalPraise();
        } else {
          this.$createToast({
            txt: '点赞失败',
            type: 'error'
          }).show();
        }
      });
    },
    share() {
      this.$store.commit('SET_CURRENT_LIVE_ITEM', this.detail);
      let mobile = this.userInfo.mobile;
      this.$router.push(
        `/share?liveId=${this.detail.liveId}&schoolName=${this.detail.schoolName}&streamStatus=${
          this.detail.streamStatus
        }&mobile=${mobile}`
      );
    },
    changeShowLogin(flag) {
      this.isShowLogin = flag;
    },
    handleVideoChange(params) {
      const { url } = params;
      if (params.index === 0) {
        if (this.detail.liveStatus === 0) {
          this.flag = true;
          this.haveVideo = true;
          this.videoPlaying = true;
          setTimeout(() => {
            // this.$refs.player.live = true;
            this.$refs.player.living = true;
            this.$refs.player.haveVideo = true;
            this.$refs.player.url = url;
            this.$refs.player.initPlayer();
          }, 300);
        } else {
          this.haveVideo = false;
        }
      } else {
        this.flag = false;
        this.haveVideo = true;
        this.videoPlaying = true;
        setTimeout(() => {
          // this.$refs.player.live = false;
          this.$refs.player.living = false;
          this.$refs.player.haveVideo = true;
          this.$refs.player.url = url;
          this.$refs.player.initPlayer();
        }, 300);
      }
    },
    tolive() {
      const url = this.detail.livePlayHlsUrl;
      if (this.detail.liveStatus === 2 || this.detail.liveStatus === 1) {
        this.haveVideo = false;
        this.videoPlaying = false;
      } else {
        this.videoPlaying = false;
        this.$refs.player.haveVideo = false;
        this.$refs.player.url = url;
        this.$refs.player.initPlayer();
      }
    },
    back() {
      this.$router ? this.$router.back() : window.history.back();
    },
    getLiveDetail(isPraise) {
      let schoolName = this.$route.params.schoolName;
      // 推流状态
      if (typeof this.$route.params.streamStatus != 'undefined') {
        this.streamStatus = this.$route.params.streamStatus;
      }
      const params = {
        liveId: this.liveId,
        schoolName: schoolName
      };
      liveApi.fetchLiveCodeDetail(params).then(response => {
        if (response.code === 0) {
          this.detail = response.result;
          document.title = this.detail.liveTitle;
          // 针对部分IOS修改title无效做特殊处理
          let iframe = document.createElement('iframe');
          iframe.src = require('../../../../public/favicon.png');
          iframe.style.display = 'none';
          let fn = function() {
            setTimeout(function() {
              iframe.removeEventListener('load', fn);
              document.body.removeChild(iframe);
              console.log('title', document.title);
            }, 0);
          };
          iframe.addEventListener('load', fn);
          document.body.appendChild(iframe);
          if (this.detail.videoList === '') {
            this.detail.videoList = [];
          }
          this.getTotalPraise();
          if (!isPraise) {
            if (response.result.liveStatus !== 2) {
              this.addViews();
            }
          }
        }
      });
    },
    getInfo() {
      let schoolName = this.$route.params.schoolName;
      // 推流状态
      if (typeof this.$route.params.streamStatus != 'undefined') {
        this.streamStatus = this.$route.params.streamStatus;
      }
      const params = {
        liveId: this.liveId,
        schoolName: schoolName
      };
      liveApi.fetchLiveCodeDetailForStatus(params).then(response => {
        if (response.code === 0) {
          this.detail.livePlayHlsUrl = response.result.livePlayHlsUrl;
          this.detail.liveStatus = response.result.liveStatus;
        }
      });
    },
    addViews() {
      const params = {
        liveId: this.liveId
      };
      liveApi.addViewsCode(params);
    },
    showLogin() {
      this.$refs.popup.show(true);
      // this.$refs.player && this.$refs.player.pause();
      this.$refs.player && this.$refs.player.stopPlayer();
    },
    resetPlay() {
      // this.$refs.player && this.$refs.player.play();
      this.$refs.player && this.$refs.player.startPlayer();
      let visitorInfo = JSON.parse(global.localStorage.getItem('visitorInfo'));
      if (visitorInfo.mobile) {
        this.getLiveDetail();
      }
    },
    endHandler() {
      this.isStart = true;
    },
    urlError() {
      // this.isStart = false;
      this.tips = this.liveEnd ? '老师已下课，谢谢观看' : '休息一下，等老师回来';
      if (this.tips === '老师已下课，谢谢观看') {
        this.isStart = false;
      }
    },
    handleFullScreen(isFullScreen) {
      this.isFullScreen = isFullScreen;
    },
  }
};
</script>

<style lang="less" scoped>
.live-detail {
  position: relative;

  /* 悬浮按钮 */

  .float-operation {
    position: fixed;
    top: 460px !important;
    width: 65px !important;
    right: 15px !important;
    z-index: 99;
    text-align: center;
  }

  .float-operation img {
    width: 62px;
    height: 62rpx;
    margin-bottom: -10px;
    opacity: 0.9;
  }

  .gray {
    color: #949494 !important;
  }

  .float-operation span {
    display: block;
    margin-top: 10px;
    position: relative;
    color: #ffc329;
  }

  .share-btn {
    padding: 0;
    border: 0;
    background-color: #fff;
    margin-bottom: -10px;
  }

  .share-btn::after {
    border: 0;
  }

  button[plain] {
    border: 0;
  }

  .player {
    background: #000;
    .course-tip {
      font-size: 14px;
      color: #ccc;
      // padding-top: 90px;
      width: 100%;
      height: 100%;
      display: flex;
      justify-content: center;
      align-items: center;
    }
  }

  .icon {
    position: absolute;
    left: 15px;
    top: 15px;
    z-index: 10001;
    // background-color: #5556;
    color: #fff;
    font-size: 18px;
    img {
      width: 20px;
      height: 20px;
    }
  }

  .liveto {
    position: fixed;
    right: 15px;
    top: 18px;
    z-index: 10001;
    font-size: 12px;
    color: #fff;
    // font-size: 18px;
  }
}
</style>
